import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import transactions from "./transactions/index.js";
import register from "./register/index.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    transactions,
    register,
  },
  state: {
    token: localStorage.getItem("token"),
    errors: [],
    prevPath: "",
    nextPath: "",
    flashMessage: "",
    infrastruktur: null,
    fasilitasmasjid: null,
    sosialkeumatan: null,
    pemberdayaanekonomi: null,
    pendidikandakwah: null,
    lingkunganmasjid: null,
    kesejahteraanmasjid: null,
  },
  getters: {
    isAuth: (state) => {
      return state.token != "null" && state.token != null;
    },
  },
  mutations: {
    SET_PREVIOUS_PATH(state, payload) {
      state.prevPath = payload;
    },
    SET_NEXT_PATH(state, payload) {
      state.nextPath = payload;
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
    },
    SET_ERRORS(state, payload) {
      state.errors = payload;
    },
    CLEAR_ERRORS(state) {
      state.errors = [];
    },
    SET_FLASH_MESSAGE(state, payload) {
      state.flashMessage = payload;
    },
    SET_INFRA(state, payload) {
      state.infrastruktur = payload;
    },
    SET_FASILITAS(state, payload) {
      state.fasilitasmasjid = payload;
    },
    SET_SOSIAL(state, payload) {
      state.sosialkeumatan = payload;
    },
    SET_PEMBERDAYAAN(state, payload) {
      state.pemberdayaanekonomi = payload;
    },
    SET_PENDIDIKAN(state, payload) {
      state.pendidikandakwah = payload;
    },
    SET_LINGKUNGAN(state, payload) {
      state.lingkunganmasjid = payload;
    },
    SET_KESEJAHTERAAN(state, payload) {
      state.kesejahteraanmasjid = payload;
    },
  },
  actions: {
    setFlashMessage({ commit }, payload) {
      commit("SET_FLASH_MESSAGE", payload);
    },
    setNextPath({ commit }, payload) {
      commit("SET_CURRENT_PATH", payload);
    },
    setPrevPath({ commit }, payload) {
      commit("SET_PREVIOUS_PATH", payload);
    },
    setInfrastruktur({ commit }, payload) {
      commit("SET_INFRA", payload);
    },
    setFasilitas({ commit }, payload) {
      commit("SET_FASILITAS", payload);
    },
    setSosial({ commit }, payload) {
      commit("SET_SOSIAL", payload);
    },
    setPemberdayaan({ commit }, payload) {
      commit("SET_PEMBERDAYAAN", payload);
    },
    setPendidikan({ commit }, payload) {
      commit("SET_PENDIDIKAN", payload);
    },
    setLingkungan({ commit }, payload) {
      commit("SET_LINGKUNGAN", payload);
    },
    setKesejahteraan({ commit }, payload) {
      commit("SET_KESEJAHTERAAN", payload);
    },
  },
  plugins: [createPersistedState()],
});

export default store;
